/**
 * 格式化千位分隔数字，保留原始小数位。
 * @param {number|string} value 需要格式化的数字
 * @returns {string} 千位分隔后的展示文本
 */
export const formatThousandsNumber = (value) => {
  if (value === undefined || value === null || value === "") {
    return "0";
  }

  const text = String(value).trim();

  if (!text) {
    return "0";
  }

  const normalizedText = text.replace(/,/g, "");
  const numericValue = Number(normalizedText);

  if (!Number.isFinite(numericValue)) {
    return text;
  }

  const [integerPart, decimalPart] = normalizedText.split(".");
  const sign = integerPart.startsWith("-") ? "-" : "";
  const unsignedInteger = sign ? integerPart.slice(1) : integerPart;
  const formattedInteger = unsignedInteger.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  return `${sign}${formattedInteger}${decimalPart !== undefined ? `.${decimalPart}` : ""}`;
};
